import { ThemedText } from "@/components/themed-text";
import { completeOAuthLogin } from "@/components/ui/oauth";
import { Loader } from "@/components/ui/loader";
import { BrandColors, Colors } from "@/constants/theme";
import { showToast } from "@/lib/toast";
import * as Linking from "expo-linking";
import { router } from "expo-router";
import * as WebBrowser from "expo-web-browser";
import React, { useEffect, useRef } from "react";
import { Platform, StyleSheet, View, useColorScheme } from "react-native";

// Required so the OAuth popup can close and return control to the opener on web.
WebBrowser.maybeCompleteAuthSession();

export default function CallbackScreen() {
  const colorScheme = useColorScheme();
  const theme = Colors[colorScheme ?? "light"];
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) {
      return;
    }
    handled.current = true;

    const completion = WebBrowser.maybeCompleteAuthSession();

    // Popup flow: parent AuthSession handles login from the returned URL.
    if (completion.type === "success") {
      return;
    }

    // Full-page / deep-link fallback: complete login on this screen.
    const url = Linking.getLinkingURL() ?? (Platform.OS === "web"
      ? typeof window !== "undefined"
        ? window.location.href
        : null
      : null);

    if (!url || !url.includes("token=")) {
      router.replace("/(auth)");
      return;
    }

    const result = completeOAuthLogin(url);
    if (!result.ok) {
      showToast.error(
        result.error ?? "Failed to sign in with social login. Please try again.",
      );
      router.replace("/(auth)");
    }
  }, []);

  return (
    <View style={[styles.container, { backgroundColor: theme.background }]}>
      <Loader />
      <ThemedText style={styles.text} type="subtitle">
        Completing sign-in...
      </ThemedText>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    gap: 16,
  },
  text: {
    color: BrandColors.mediumGray,
    fontSize: 16,
  },
});
